// :cow: Cosmose CONFIDENTIAL :iso:
export const AppConfig = {
  accessToken: 'coa_access_token',
  refreshToken: 'coa_refresh_token',
};
